module.exports = __webpack_public_path__ + "img/jierjisi.d6224abd.png";